import { forwardRef } from "react";

import type {
  TRadioGroupSkeletonProps,
} from "@/ui/components/form/RadioGroup/RadioGroup.config";
import {
  SkeletonBlock,
} from "@/ui/components/primitives/Skeleton/SkeletonBlock";
import { cn } from "@/ui/lib/utils";
import { Stack } from "@/ui/components/layout";

export const RadioGroupSkeleton = forwardRef<
  HTMLDivElement,
  TRadioGroupSkeletonProps
>(({ className, optionCount, ...props }, ref) => (
  <div
    {...props}
    ref={ref}
    aria-hidden="true"
    data-component="RadioGroupSkeleton"
    className={cn("w-full animate-pulse", className)}
  >
    <Stack>
      { Array.from({ length: optionCount }, (_, index) => (
        <SkeletonBlock
          key={index}
          className="h-16 w-full rounded-sys-md"
        />
      )) }
    </Stack>
  </div>
));

RadioGroupSkeleton.displayName = "RadioGroupSkeleton";
